var map = {
	"./air-nga-en/assets/my-rounds-nav-icon-active.png": 95909,
	"./ais-tai-en/assets/my-rounds-nav-icon-active.png": 70468,
	"./ais-tai-tha/assets/my-rounds-nav-icon-active.png": 26560,
	"./demo-arabic/assets/my-rounds-nav-icon-active.png": 24568,
	"./demo-et-en/assets/my-rounds-nav-icon-active.png": 69177,
	"./demo-romanian/assets/my-rounds-nav-icon-active.png": 93203,
	"./demo-um-en/assets/my-rounds-nav-icon-active.png": 25336,
	"./dtac-tai-en/assets/my-rounds-nav-icon-active.png": 95187,
	"./dtac-tai-tha/assets/my-rounds-nav-icon-active.png": 19869,
	"./ethiotel-et-amh/assets/my-rounds-nav-icon-active.png": 75775,
	"./ethiotel-et-en/assets/my-rounds-nav-icon-active.png": 66722,
	"./mtn-cg-fr/assets/my-rounds-nav-icon-active.png": 84007,
	"./mtn-ci-fr/assets/my-rounds-nav-icon-active.png": 6157,
	"./mtn-cmr-fr/assets/my-rounds-nav-icon-active.png": 90657,
	"./mtn-gha-en/assets/my-rounds-nav-icon-active.png": 74954,
	"./mtn-nga-en/assets/my-rounds-nav-icon-active.png": 43870,
	"./mtn-zam-en/assets/my-rounds-nav-icon-active.png": 45944,
	"./saf-ke-en/assets/my-rounds-nav-icon-active.png": 72721,
	"./saudi-uae-en/assets/my-rounds-nav-icon-active.png": 89000,
	"./tlk-za-en/assets/my-rounds-nav-icon-active.png": 89061,
	"./vc-za-en/assets/my-rounds-nav-icon-active.png": 86849
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 91487;